import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthLayoutComponent } from '@shared/layout/auth-layout/auth-layout.component';
import { routesMaintance } from './modules/maintenance/maintence.routes';
import { routesOperations } from './modules/operations/operations.routes';
import { RoleGuard } from '@shared/guards/role.guard';

export const routes: Routes = [
  {
    path: 'listas',
    component: AuthLayoutComponent,
    data: { breadcrumb: 'Listas' },
    canActivate: [MsalGuard],
    children: [
      {
        path: 'menu',
        data: { breadcrumb: 'Operaciones básicas' },
        loadComponent: () =>
          import('./modules/listas/pages/menu/menu.component'),
      },
      ...routesOperations,
      ...routesMaintance,
      {
        path: '0001',
        data: { breadcrumb: '0001' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './modules/listas/pages/managementmenu/managementmenu.component'
              ).then(m => m.ManagementmenuComponent),
          }
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '0002',
        data: { breadcrumb: '0002' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './modules/listas/pages/report-generate/report-generate.component'
              ).then(m => m.ReportGenerateComponent),
          }
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1004',
        data: { breadcrumb: '1004' },
        children: [
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-control/filter/bvcopc10041.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-control/table/bvcopc10042.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-control/detail/bvcopc10043.component'
              ),
          },
          {
            path: 'actualizaciones',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-control/improvements/bvcopc10044.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1007',
        data: { breadcrumb: '1007' },
        children: [
          {
            path: 'tablas',

            loadComponent: () =>
              import(
                './modules/listas/pages/cx-list-categories/tables/tables.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/cx-list-categories/detail/detail.component'
              ),
          },
          {
            path: 'actualizaciones',

            loadComponent: () =>
              import(
                './modules/listas/pages/cx-list-categories/improvements/improvements.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1008',
        data: { breadcrumb: '1008' },
        children: [
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/control-list-file-conversion/table/table.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/control-list-file-conversion/detail/detail.component'
              ),
          },
          {
            path: 'actualizaciones',

            loadComponent: () =>
              import(
                './modules/listas/pages/control-list-file-conversion/improvements/improvements.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },

      {
        path: '1013',
        data: { breadcrumb: '1013' },
        children: [
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-control/filter/filter.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-control/table/table.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-control/detail/detail.component'
              ),
          },
          {
            path: '**',
            redirectTo: 'filtro',
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1014',
        data: { breadcrumb: '1014' },
        children: [
          {
            path: 'tabla',
            data: { breadcrumb: 'tabla' },
            loadComponent: () =>
              import(
                './modules/listas/pages/system-parametrization-1014/main-table/bvcrmlcsp1/bvcrmlcsp1.component'
              ).then((m) => m.BVCRMLCSP1Component),
          },
          {
            path: 'crud',
            data: { breadcrumb: 'crud' },
            loadComponent: () =>
              import(
                './modules/listas/pages/system-parametrization-1014/crud/bvcrmlcsp2/bvcrmlcsp2.component'
              ).then((m) => m.BVCRMLCSP2Component),
          },
          {
            path: 'crud/:action/:system/:product',
            data: { breadcrumb: 'crud' },
            loadComponent: () =>
              import(
                './modules/listas/pages/system-parametrization-1014/crud/bvcrmlcsp2/bvcrmlcsp2.component'
              ).then((m) => m.BVCRMLCSP2Component),
          },
          {
            path: 'categories/:system/:product/crd/:action/:category/:use',
            data: { breadcrumb: 'categorías' },
            loadComponent: () =>
              import(
                '././modules/listas/pages/system-parametrization-1014/categories/crd/bvcrmlccat2/bvcrmlccat2.component'
              ).then((m) => m.BVCRMLCCAT2Component),
          },
          {
            path: 'categories/:system/:product/crd',
            data: { breadcrumb: 'categorías' },
            loadComponent: () =>
              import(
                '././modules/listas/pages/system-parametrization-1014/categories/crd/bvcrmlccat2/bvcrmlccat2.component'
              ).then((m) => m.BVCRMLCCAT2Component),
          },
          {
            path: 'categories/:system/:product',
            data: { breadcrumb: 'categorías' },
            loadComponent: () =>
              import(
                './modules/listas/pages/system-parametrization-1014/categories/table/bvcrmlccat1/bvcrmlccat1.component'
              ).then((m) => m.BVCRMLCCAT1Component),
          },
          {
            path: '**',
            redirectTo: 'tabla',
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1015',
        data: { breadcrumb: '1015' },
        children: [
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/category-active-inactive-switch/table/table.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1016',
        data: { breadcrumb: '1016' },
        children: [
          {
            path: 'tabla',
            data: { breadcrumb: 'tabla' },
            loadComponent: () =>
              import(
                './modules/listas/pages/parameterization-of-files1016/table/bvcrvafpar10161.component'
              ),
          },
          {
            path: 'crud',
            data: { breadcrumb: 'CRUD' },
            loadComponent: () =>
              import(
                './modules/listas/pages/parameterization-of-files1016/crud/bvcrvafpar10162.component'
              ),
          },
          {
            path: 'crud/:action',
            data: { breadcrumb: 'CRUD' },
            loadComponent: () =>
              import(
                './modules/listas/pages/parameterization-of-files1016/crud/bvcrvafpar10162.component'
              ),
          },
          {
            path: '**',
            redirectTo: 'tabla',
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1017',
        data: { breadcrumb: '1017' },
        loadComponent: () =>
          import(
            './modules/listas/pages/remove-update-person-1017/bvcffctlpe1017-remove-update-person.component'
          ),
        canActivate: [RoleGuard],
      },
      {
        path: '1018',
        data: { breadcrumb: '1018' },
        loadComponent: () =>
          import(
            './modules/listas/pages/remove-or-modify-category-1018/remove-or-modify-category-1018.component'
          ).then((m) => m.RemoveOrModifyCategory1018Component),
        canActivate: [RoleGuard],
      },
      {
        path: '1019',
        data: { breadcrumb: '1019' },
        children: [
          {
            path: '',
            data: { breadcrumb: 'Consulta' },
            loadComponent: () =>
              import(
                './modules/listas/pages/personal-data-clearing/personal-data-clearing.component'
              ),
          },
          {
            path: ':idPeople',
            data: { breadcrumb: 'Detalle' },
            loadComponent: () =>
              import(
                './modules/listas/pages/personal-data-clearing-detail/personal-data-clearing-detail.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1020',
        data: { breadcrumb: '1020' },
        children: [
          {
            path: '',
            data: { breadcrumb: 'Consulta' },
            loadComponent: () =>
              import(
                './modules/listas/pages/debugging-inconsistent-information-LLI-1020/bvcrmcolli-table/bvcrmcolli-table.component'
              ).then((m) => m.BvcrmcolliTableComponent),
          },
          {
            path: 'form',
            data: { breadcrumb: 'Formulario' },
            loadComponent: () =>
              import(
                './modules/listas/pages/debugging-inconsistent-information-LLI-1020/bvcrmcolli-form/bvcrmcolli-form.component'
              ).then((m) => m.BvcrmcolliFormComponent),
          },
          {
            path: 'person',
            data: { breadcrumb: 'Persona' },
            loadComponent: () =>
              import(
                './modules/listas/pages/debugging-inconsistent-information-LLI-1020/bvcrmcolli-table-person/bvcrmcolli-table-person.component'
              ).then((m) => m.BvcrmcolliTablePersonComponent),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1021',
        data: { breadcrumb: '1021' },
        loadComponent: () =>
          import(
            './modules/listas/pages/depuration-users/depuration-users.component'
          ).then((m) => m.DepurationUsersComponent),
          canActivate: [RoleGuard],
      },
      {
        path: '1025',
        data: { breadcrumb: '1025' },
        children: [
          {
            path: ':listType/:personType/:code/:versionNumber/grupos',
            data: { breadcrumb: 'Consulta Grupos' },
            loadComponent: () =>
              import(
                './modules/listas/pages/ofac-onu-1025/ofac-onu-history-detail-table/ofac-onu-history-detail-table.component'
              )
          },
          {
            path: ':listType/:personType/:code/:versionNumber/:groupName',
            data: { breadcrumb: 'Detalle de grupos' },
            loadComponent: () =>
              import(
                './modules/listas/pages/ofac-onu-1025/ofac-onu-history-detail/ofac-onu-history-detail.component'
              )
          },
          // {
          //   path: ':listType/:personType/:code/:versionNumber/grupos/:group',
          //   data: { breadcrumb: 'Consulta Grupos' },
          //   loadComponent: () =>
          //     import('./modules/listas/pages/ofac-onu-1025/ofac-onu-history-detail-table/ofac-onu-history-detail-table.component')
          //       .then(m => m.default)
          // },
          {
            path: ':listType/:personType/:code/:versionNumber',
            data: { breadcrumb: 'Detalle del registro' },
            loadComponent: () =>
              import(
                './modules/listas/pages/ofac-onu-1025/ofac-onu-history-detail/ofac-onu-history-detail.component'
              )
          },

          {
            path: '',
            data: { breadcrumb: 'Consulta' },
            loadComponent: () =>
              import(
                './modules/listas/pages/ofac-onu-1025/ofac-onu-history-list/ofac-onu-history-list.component'
              )
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1022',
        data: { breadcrumb: '1022' },
        loadComponent: () =>
          import(
            './modules/listas/pages/depuracion-automatica-1022/bvcoconsdn1022-depuracion-automatica.component'
          ),
        canActivate: [RoleGuard],
      },
      {
        path: '1026',
        data: { breadcrumb: '1026' },
        children: [
          {
            path: '',

            loadComponent: () =>
              import(
                './modules/listas/pages/ofac-onu-manual-summary/info/info.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1029',
        data: { breadcrumb: '1029' },
        children: [
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-external-lawyers/filter/bvcopc10291.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-external-lawyers/table/bvcopc10292.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/list-external-lawyers/detail/bvcopc10293.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1031',
        data: { breadcrumb: '1031' },
        loadComponent: () =>
          import(
            './modules/listas/pages/file-generation-1031/file-generation-1031.component'
          ).then((m) => m.FileGeneration1031Component),
          canActivate: [RoleGuard],
      },
      {
        path: '1033',
        data: { breadcrumb: '1033' },
        children: [
          {
            path: 'info',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/info/info.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/table/table.component'
              ),
          },
          {
            path: 'detalle',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/detail/detail.component'
              ),
          },
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/filter/filter.component'
              ),
          },
          {
            path: 'carga-masiva',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/bulk-upload/bulk-upload.component'
              ),
          },
          {
            path: 'cambio-estados',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/change-state-pe/change-state-pe.component'
              ),
          },
          {
            path: 'tabla-lc',

            loadComponent: () =>
              import(
                './modules/listas/pages/homonymous-client-managment/table-lc/table-lc.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1035',
        data: { breadcrumb: '1035' },
        children: [
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-service-log/filter/filter.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-service-log/table/table.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/consult-list-service-log/detail/detail.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1036',
        data: { breadcrumb: '1036' },
        children: [
          {
            path: 'filtro',

            loadComponent: () =>
              import(
                './modules/listas/pages/list_Search_Methods/filter/filter.component'
              ),
          },
          {
            path: 'tabla',

            loadComponent: () =>
              import(
                './modules/listas/pages/list_Search_Methods/table/table.component'
              ),
          },
          {
            path: 'detalles',

            loadComponent: () =>
              import(
                './modules/listas/pages/list_Search_Methods/detail/detail.component'
              ),
          },
          {
            path: 'actualizaciones',

            loadComponent: () =>
              import(
                './modules/listas/pages/list_Search_Methods/improvements/improvements.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1037',
        data: { breadcrumb: '1037' },
        children: [
          {
            path: ':id/:category/:subcategory',
            data: { breadcrumb: '' },
            loadComponent: () =>
              import(
                '././modules/listas/pages/response-evaluation-in-control-lists-1037/item-detail/bvcrconslc3/bvcrconslc3.component'
                ),
          },
          {
            path: '',
            data: { breadcrumb: '' },
            loadComponent: () =>
              import(
                './modules/listas/pages/response-evaluation-in-control-lists-1037/form/bvcrconslc1/bvcrconslc1.component'
              ),
          },
          {
            path: ':id',
            data: { breadcrumb: '' },
            loadComponent: () =>
              import(
                '././modules/listas/pages/response-evaluation-in-control-lists-1037/consult/bvcrconslc2/bvcrconslc2.component'
              ),
          },
        ],
        canActivate: [RoleGuard],
      },
      {
        path: '1039',
        data: { breadcrumb: '1039' },
        loadComponent: () =>
          import(
            './modules/listas/pages/mass-change-system-in-control-lists-1039/mass-change-system-in-control-lists-1039.component'
          ).then(m => m.MassChangeSystemInControlLists1039Component),
          canActivate: [RoleGuard],
      },
      {
        path: '**',
        redirectTo: '/listas/menu',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/listas/menu',
    pathMatch: 'full',
  },
];
